import { useState } from "react"
import { Tab, Tabs } from "react-bootstrap"
import Departments from "./Departments"
import Users from "./Users"
import Blocks from "./Blocks"
import CalendarSettings from "./CalendarSettings"

const Settings = () => {
  const [key, setKey] = useState("departments")

  return (
    <Tabs id="settings-tabs" activeKey={key} onSelect={(k) => setKey(k)} className="tabs-primary mb-3">
      <Tab eventKey="departments" title="Středisko">
        <Departments tabActive={key === "departments"} />
      </Tab>
      <Tab eventKey="users" title="Uživatelé">
        <Users tabActive={key === "users"} />
      </Tab>
      <Tab eventKey="blocks" title="Blokace">
        <Blocks tabActive={key === "blocks"} />
      </Tab>
      <Tab eventKey="calendar" title="Kalendář">
        <CalendarSettings tabActive={key === "calendar"} />
      </Tab>
    </Tabs>
  )
}

export default Settings
